{
  "让机械臂够到杯子 · 物理AI实验室 Lab 1.1": {
    "en": "Get the arm to reach the cup · Physical AI Lab 1.1",
    "ja": "ロボットアームでコップに届く · Physical AI Lab 1.1"
  },
  "让机械臂够到杯子": {
    "en": "Get the arm to reach the cup",
    "ja": "アームをコップに届かせる"
  },
  "拖动杯子：先<span class=\"ok\">看到</span>它在哪，再<span style=\"color:var(--think)\">算出</span>三个关节角，最后电机把手<span style=\"color:var(--act)\">转过去</span>。": {
    "en": "Drag the cup: first <span class=\"ok\">see</span> where it is, then <span style=\"color:var(--think)\">work out</span> three joint angles, and the motors <span style=\"color:var(--act)\">swing</span> the hand there.",
    "ja": "コップをドラッグ：まず位置を<span class=\"ok\">見て</span>、<br>三つの関節角を<span style=\"color:var(--think)\">計算し</span>、<br>最後にモーターが手を<span style=\"color:var(--act)\">動かします</span>。"
  },
  "正运动学：拖动滑块给出关节角，算出手在哪里。反过来，从“手要去哪”求关节角，就是逆运动学。": {
    "en": "Forward kinematics: set the joint angles with the sliders and get where the hand is. The other way round, from \"where the hand should go\" to joint angles, is inverse kinematics.",
    "ja": "順運動学：スライダーの関節角から手の位置を求める。逆に、手の行き先から関節角を求めるのが逆運動学。"
  },
  "关节 · joints": {
    "en": "Joints",
    "ja": "関節 · joints"
  },
  "看": {
    "en": "See",
    "ja": "見る"
  },
  "想": {
    "en": "Think",
    "ja": "考える"
  },
  "动": {
    "en": "Act",
    "ja": "動く"
  },
  "底座": {
    "en": "Base",
    "ja": "土台"
  },
  "肩": {
    "en": "Shoulder",
    "ja": "肩"
  },
  "肘": {
    "en": "Elbow",
    "ja": "ひじ"
  },
  "手 · end effector": {
    "en": "Hand · end effector",
    "ja": "手先 · end effector"
  },
  "逆运动学 IK": {
    "en": "Inverse (IK)",
    "ja": "逆運動学 IK"
  },
  "正运动学 FK": {
    "en": "Forward (FK)",
    "ja": "順運動学 FK"
  },
  "电机速度": {
    "en": "Motor speed",
    "ja": "モーター速度"
  },
  "显示“想”：规划出的姿态": {
    "en": "Show \"Think\": the planned pose",
    "ja": "「考える」を表示：計画した姿勢"
  },
  "显示“看”：相机视野": {
    "en": "Show \"See\": the camera's view",
    "ja": "「見る」を表示：カメラの視野"
  },
  "相机 15 Hz": {
    "en": "Camera 15 Hz",
    "ja": "カメラ 15 Hz"
  },
  "逆运动学": {
    "en": "Inverse kinematics",
    "ja": "逆運動学"
  },
  "误差 0 mm": {
    "en": "Error 0 mm",
    "ja": "誤差 0 mm"
  },
  "拖动杯子 · 拖动空白处旋转视角 · 滚轮缩放": {
    "en": "Drag the cup · drag empty space to orbit · scroll to zoom",
    "ja": "コップをドラッグ · 空いた所をドラッグして視点を回す · ホイールでズーム"
  },
  "不用看": {
    "en": "Not needed",
    "ja": "見なくていい"
  },
  "杯子 {0}": {
    "en": "Cup {0}",
    "ja": "コップ {0}"
  },
  "你给关节角": {
    "en": "You set the angles",
    "ja": "関節角は手入力"
  },
  "无解：太远了": {
    "en": "No solution: too far",
    "ja": "解なし：遠すぎる"
  },
  "太近：会撞到底座": {
    "en": "Too close: hits base",
    "ja": "近すぎ：土台に当たる"
  },
  "逆运动学 · 有解": {
    "en": "IK · solved",
    "ja": "逆運動学 · 解あり"
  },
  "电机跟随滑块": {
    "en": "Motors follow sliders",
    "ja": "モーターがスライダーに追従"
  },
  "离杯子 {0} mm": {
    "en": "{0} mm to the cup",
    "ja": "コップまで {0} mm"
  },
  "关节角 → 手的位置": {
    "en": "joint angles → hand position",
    "ja": "関節角 → 手の位置"
  },
  "超出 {0} cm": {
    "en": "{0} cm beyond reach",
    "ja": "{0} cm はみ出し"
  },
  "太靠近底座": {
    "en": "too close to the base",
    "ja": "土台に近すぎる"
  },
  "够到了": {
    "en": "got it",
    "ja": "届いた"
  },
  "电机转动中": {
    "en": "motors turning",
    "ja": "モーター回転中"
  },
  "TARGET · 够不着": {
    "en": "TARGET · OUT OF REACH",
    "ja": "TARGET · 届かない"
  },
  "TARGET · 太近": {
    "en": "TARGET · TOO CLOSE",
    "ja": "TARGET · 近すぎ"
  },
  "TARGET · 已够到": {
    "en": "TARGET · REACHED",
    "ja": "TARGET · 到達"
  }
}
